"use client";
import { jsxs as c, jsx as a } from "react/jsx-runtime";
const t = ({
  title: l,
  titleId: r,
  desc: e,
  descId: h,
  ...i
}) => /* @__PURE__ */ c(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": r,
    "aria-describedby": h,
    ...i,
    children: [
      e ? /* @__PURE__ */ a("desc", { id: h, children: e }) : null,
      l ? /* @__PURE__ */ a("title", { id: r, children: l }) : null,
      /* @__PURE__ */ a(
        "path",
        {
          stroke: "currentColor",
          strokeWidth: 0.4,
          d: "M11.027 21.953a.794.794 0 0 1-1.588 0V7.217c0-.438.356-.794.794-.794h2.56V4.128c0-.438.355-.794.793-.794H32.54c.439 0 .794.356.794.794v25.368a.794.794 0 0 1-.794.794h-2.56v2.294a.794.794 0 0 1-.794.794h-9.078a.794.794 0 0 1 0-1.588h8.286V8.008H11.029V21.95zm-2.334 9.171a.795.795 0 0 1 1.123-1.123l1.18 1.18 2.857-3.345a.794.794 0 0 1 1.117-.087c.332.284.37.785.087 1.117l-3.377 3.953a.795.795 0 0 1-1.2.09l-1.786-1.785zm3.162 4.493a5.25 5.25 0 0 0 3.724-1.542 5.25 5.25 0 0 0 1.543-3.724 5.25 5.25 0 0 0-1.543-3.725 5.25 5.25 0 0 0-3.724-1.542 5.25 5.25 0 0 0-3.725 1.542 5.25 5.25 0 0 0-1.542 3.725 5.25 5.25 0 0 0 1.542 3.724 5.25 5.25 0 0 0 3.725 1.542Zm4.847-.42a6.834 6.834 0 0 1-4.847 2.007 6.834 6.834 0 0 1-4.847-2.008A6.834 6.834 0 0 1 5 30.35a6.84 6.84 0 0 1 2.008-4.847 6.834 6.834 0 0 1 4.847-2.008c1.893 0 3.605.767 4.847 2.008a6.833 6.833 0 0 1 2.008 4.847 6.833 6.833 0 0 1-2.008 4.848Zm-2.857-14.772a.794.794 0 0 1 0-1.588h6.258a.794.794 0 0 1 0 1.588zm10.086 0a.794.794 0 0 1 0-1.588h1.648a.794.794 0 0 1 0 1.588zm-10.086-4.25a.794.794 0 0 1 0-1.588H25.58a.794.794 0 0 1 0 1.588zm0-4.25a.794.794 0 0 1 0-1.588H25.58a.794.794 0 0 1 0 1.588zm.539-5.502h14.805c.439 0 .795.356.795.794v21.487h1.764V4.924H14.384v1.5Z"
        }
      )
    ]
  }
);
export {
  t as default
};
